module.exports = __webpack_public_path__ + "static/img/invitecode.ee1f8e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/my/invitecode.png
// module id = s0wZ
// module chunks = 82